import { ComponentType, createElement as e } from 'react';

/**
 * Wraps a component type in another component type that maps its own properties to those of the wrapped component using a mapping function.
 *
 * @param map The mapping function
 */
const remapProps =
  <P1 extends {}, P2 extends {}>(map: (props: P1) => P2) =>
  (component: ComponentType<P2>) =>
  (props: P1) => {
    const innerProps = map(props);
    return e(component, innerProps);
  };

export default remapProps;
